import { useSelector } from 'react-redux'

// slices
import { loginState } from '../login/login.slice'

// page FOF
import FoF from '../404/404.index'
import { canSeeHeaderNavigationTabs } from '../../helpers/checkNavigationPermission'
import { PRIVATE_ROUTES } from '../../routes'

const ADMIN_HEADER_ROUTE_PATHS = new Set([
    PRIVATE_ROUTES.users,
    PRIVATE_ROUTES.projects.root,
    PRIVATE_ROUTES.reports,
])

function PermissionRoutes({ keyPath, children }) {
    const { userProfile } = useSelector(loginState)

    if (
        ADMIN_HEADER_ROUTE_PATHS.has(keyPath) &&
        !canSeeHeaderNavigationTabs(userProfile)
    ) {
        return <FoF />
    }

    if (
        userProfile?.role?.containers.some(
            (data) => data?.container === keyPath
        )
    ) {
        return children
    } else {
        return <FoF />
    }
}

export default PermissionRoutes
